/* eslint-disable max-len */
export const Routes = {
    DASHBOARD: 'dashboard',
    CONSIGNMENTS: 'consignments',
    PLUGIN_ORDERS: 'plugin-orders',
    PICKUPS: 'pickups',
    ADDRESS_BOOK: 'address-book',
    VIRTUAL_INVENTORY: 'virtual-inventory',
    DOWNLOADS: 'downloads',
    WALLET: 'wallet',
    WALLET_LEDGER: 'vallet/ledger',
    RECHARGE_TRANSACTIONS: 'vallet/recharge-transactions',
    BLOCKED_AMOUNT_LEDGER: 'vallet/blocked-amount',
    INVOICE: 'invoice',
    HELP: 'help',
    PLUGIN: 'plugin',
    TUTORIAL: 'tutorial',
    FORGOT: 'forgot-password',
    LOGIN: 'login',
    SUPER_LOGIN: 'superuser/login',
    CUSTOMER_ACTIVATION: 'customerActivation',
    RESET_PASSWORD: 'resetPassword',
    EXCEL_UPLOAD: 'consignments/excel-upload',
    PRINT_HISTORY: 'consignments/print-history',
    CONSIGNMENT_DETAILS: 'consignments/details',
    SETTINGS: 'settings',
    SETTINGS_HEADER: 'settings/header-mapping',
    SETTINGS_PIECE_HEADER: 'settings/piece-header-mapping',
    SETTINGS_INVOICE_HEADER: 'settings/invoice-header-mapping',
    SETTINGS_PRODUCT: 'settings/product-mapping',
    SETTINGS_CHANNEL: 'settings/channel-integrations',
    SETTINGS_ACCOUNT: 'settings/account',
    SCHEDULE_PICKUP: 'schedule-pickup',
    ASN: 'asn',
    ASN_EXCEL_UPLOAD: 'asn/excel-upload',
    ANALYTICS: 'analytics',
    API_PLAYGROUND: 'api-playground',
    RTO_DASHBOARD: 'rto-dashboard',
    ANALYTICS_DASHBOARD: 'analytics/dashboard',
    REMITTANCE: 'remittance',
    INVOICE_REPORT: 'reports/invoice',
    REPORT: 'reports',
    REMITTANCE_REPORT: 'reports/remittance',
    ADDITIONAL_SERVICES: 'additional-services',
    SSO_LOGIN_REQUEST: 'sso-login',
    USER_MANAGEMENT: 'user-management',
    PURCHASE_ORDER: 'purchase-order',
    INVOICES: 'invoices',
    RATE_CALCULATOR: 'rate-calculator',
    PINCODE_SERVICEABILITY: 'pincode-serviceability',
    APPOINTMENTS: 'appointments',
};


interface RouteRawDetails {
    title: string;
    isVisible: boolean | ((master: any) => boolean);
    isProtected: boolean;
}

export interface RouteDetails {
    title: string;
    isVisible: boolean;
    isProtected: boolean;
}

export const RoutesInfo: Record<keyof typeof Routes, RouteRawDetails | undefined> = {
    // undefined means the route is not available, reason for that
    // - It was previously available but now removed, as per new UI design
    ANALYTICS: {
        title: 'overview',
        isProtected: true,
        isVisible: (master: any) => {
            if (master?.properties && master?.parts_to_show?.enable_customer_config) {
                if (master?.config?.is_international_customer) {
                    return false;
                }
                return master?.properties?.Analytics;
            }
            return true;
        },
    },
    CONSIGNMENTS: {
        title: 'consignments',
        isProtected: true,
        isVisible: (master: any) => {
            return master?.customerUserPermissions?.consignment_ops;
        },
    },
    PURCHASE_ORDER: {
        title: 'purchase_orders',
        isProtected: true,
        isVisible: (master: any) => {
            return master?.properties?.enable_purchase_order;
        },
    },
    SCHEDULE_PICKUP: {
        title: 'schedule_pickup',
        isProtected: true,
        isVisible: (master: any) => {
            return master?.parts_to_show?.allow_daily_pickups_scheduling;
        },
    },
    INVOICES: {
        title: 'invoices',
        isProtected: true,
        isVisible: (master: any) => {
            return master?.config?.customer_portal_ops_config?.invoice_configuration?.config_value?.allow_invoice || false;
        },
    },
    PLUGIN_ORDERS: {
        title: 'plugin_orders',
        isProtected: true,
        isVisible: (master: any) => {
            return master?.customerUserPermissions?.pickup_ops;
        },
    },
    APPOINTMENTS: {
        title: 'appointments',
        isProtected: true,
        isVisible: (master: any) => {
            return master?.parts_to_show?.show_appointments_view || false;
        },
    },
    PICKUPS: {
        title: 'pickups',
        isProtected: true,
        isVisible: (master: any) => {
            return master?.config?.customer_portal_ops_config?.pickup_configuration?.config_value?.is_pickup_allowed || false;
        },
    },
    ADDRESS_BOOK: {
        title: 'address_book',
        isProtected: true,
        isVisible: (master: any) => {
            if (master?.properties && master?.parts_to_show?.enable_customer_config) {
                return master?.properties?.address_book && master?.customerUserPermissions?.address_book_update;
            }
            return true;
        },
    },
    VIRTUAL_INVENTORY: {
        title: 'virtual_inventory',
        isProtected: true,
        isVisible: (master: any) => {
            if (master?.properties && master?.parts_to_show?.enable_customer_config) {
                return master?.parts_to_show?.virtual_series && master?.properties?.virtual_inventory
                    && master?.customerUserPermissions?.virtual_inventory;
            }
            return master?.parts_to_show?.virtual_series;
        },
    },
    DOWNLOADS: {
        title: 'downloads',
        isProtected: true,
        isVisible: true,
    },
    WALLET: undefined,
    WALLET_LEDGER: {
        title: 'wallet_ledger',
        isProtected: true,
        isVisible: (master: any) => {
            let showWalletSectionCustomerProfile = true;
            if (master?.properties && master?.parts_to_show?.enable_customer_config) {
                showWalletSectionCustomerProfile = master?.properties?.Wallet;
            }
            if (master?.Customer?.cnc_flag && showWalletSectionCustomerProfile) {
                return true;
            }
            return false;
        },
    },
    BLOCKED_AMOUNT_LEDGER: {
        title: 'blocked_amount_ledger',
        isProtected: true,
        isVisible: (master: any) => {
            let showWalletSectionCustomerProfile = true;
            if (master?.properties && master?.parts_to_show?.enable_customer_config) {
                showWalletSectionCustomerProfile = master?.properties?.Wallet;
            }
            if (master?.Customer?.cnc_flag && showWalletSectionCustomerProfile) {
                return true;
            }
            return false;
        },
    },
    RECHARGE_TRANSACTIONS: {
        title: 'recharge_transactions',
        isProtected: true,
        isVisible: (master: any) => {
            let showWalletSectionCustomerProfile = true;
            if (master?.properties && master?.parts_to_show?.enable_customer_config) {
                showWalletSectionCustomerProfile = master?.properties?.Wallet;
            }
            if (master?.Customer?.cnc_flag && showWalletSectionCustomerProfile) {
                return true;
            }
            return false;
        },
    },
    INVOICE: undefined,
    HELP: undefined,
    PLUGIN: undefined,
    TUTORIAL: undefined,
    FORGOT: undefined,
    LOGIN: undefined,
    SUPER_LOGIN: undefined,
    CUSTOMER_ACTIVATION: undefined,
    RESET_PASSWORD: undefined,
    EXCEL_UPLOAD: {
        title: 'excel_uploaded',
        isProtected: true,
        isVisible: (master: any) => {
            if (master?.properties && master?.parts_to_show?.enable_customer_config) {
                return master?.properties?.cn_multiple_creation;
            }
            return true;
        },
    },
    PRINT_HISTORY: {
        title: 'print_history',
        isProtected: true,
        isVisible: (master: any) => {
            if (master?.properties && master?.parts_to_show?.enable_customer_config) {
                return master?.properties?.cn_multiple_creation;
            }
            return true;
        },
    },
    CONSIGNMENT_DETAILS: {
        title: 'consignment_details',
        isProtected: true,
        isVisible: true,
    },
    SETTINGS: undefined,
    SETTINGS_HEADER: {
        title: 'header_mapping',
        isProtected: true,
        isVisible: (master: any) => {
            // to honor backward compatibility, as this was in use to hide header mapping from setting
            if (master?.config?.customer_portal_config?.show_header_mapping === false
                && !master?.config?.customer_portal_ops_config?.additional_config?.config_value?.allow_header_mapping) {
                return false;
            }

            // To hide the header mapping using the configuration
            if (master?.properties && master?.parts_to_show?.enable_customer_config) {
                return master?.properties?.header_mapping_settings && master?.customerUserPermissions?.setting;
            }
            return true;
        },
    },
    SETTINGS_PIECE_HEADER: {
        title: 'piece_header_mapping',
        isProtected: true,
        isVisible: (master: any) => {
            // to honor backward compatibility, as this was in use to hide header mapping from setting
            if (master?.config?.customer_portal_config?.show_header_mapping === false
                && !master?.config?.customer_portal_ops_config?.additional_config?.config_value?.allow_header_mapping) {
                return false;
            }

            // To hide the header mapping using the configuration
            if (master?.properties && master?.parts_to_show?.enable_customer_config) {
                return master?.properties?.header_mapping_settings && master?.customerUserPermissions?.setting;
            }
            return true;
        },
    },
    SETTINGS_INVOICE_HEADER: {
        title: 'invoice_header_mapping',
        isProtected: true,
        isVisible: (master: any) => {
            // to honor backward compatibility, as this was in use to hide header mapping from setting
            if (master?.config?.customer_portal_config?.show_header_mapping === false
                && !master?.config?.customer_portal_ops_config?.additional_config?.config_value?.allow_header_mapping) {
                return false;
            }

            // To hide the header mapping using the configuration
            if (master?.properties && master?.parts_to_show?.enable_customer_config) {
                return master?.properties?.header_mapping_settings && master?.customerUserPermissions?.setting;
            }
            return true;
        },
    },
    SETTINGS_PRODUCT: {
        title: 'product_code_mapping',
        isProtected: true,
        isVisible: (master: any) => {
            // to honor backward compatibility, as this was in use to hide header mapping from setting
            if (master?.config?.customer_portal_config?.show_product_code_mapping === false) {
                return false;
            }

            // To hide the header mapping using the configuration
            if (master?.properties && master?.parts_to_show?.enable_customer_config) {
                return master?.properties?.product_code_mapping_settings && master?.customerUserPermissions?.setting;
            }
            return true;
        },
    },
    SETTINGS_CHANNEL: {
        title: 'channel_integrations',
        isProtected: true,
        isVisible: (master: any) => {
            if (master?.parts_to_show?.enable_shopify_integration) {
                return true;
            }
            if (master?.properties && master?.parts_to_show?.enable_customer_config) {
                return master?.properties?.plugin_orders;
            }
            return true;
        },
    },
    SETTINGS_ACCOUNT: {
        title: 'account_settings',
        isProtected: true,
        isVisible: true,
    },
    ASN: {
        title: 'asn',
        isProtected: true,
        isVisible: (master: any) => master?.parts_to_show?.enable_advance_shipping_note_feature || false,
    },
    ASN_EXCEL_UPLOAD: {
        title: 'ASN Excel Upload',
        isProtected: true,
        isVisible: (master: any) => master?.parts_to_show?.enable_advance_shipping_note_feature || false,
    },
    API_PLAYGROUND: {
        title: 'api_playground',
        isProtected: true,
        isVisible: (master: any) => {
            if (master?.properties && master?.parts_to_show?.enable_customer_config) {
                return master?.properties?.api_playground && master?.customerUserPermissions?.api_playground;
            }
            return true;
        },
    },
    RTO_DASHBOARD: {
        title: 'RTO Dashboard',
        isProtected: true,
        isVisible: (master: any) => {
            const flag = master?.config?.customer_portal_config?.show_rto_dashboard;
            if (master?.properties && master?.parts_to_show?.enable_customer_config) {
                return flag && master?.properties?.rto_dashboard;
            }
            return flag;
        },
    },
    ANALYTICS_DASHBOARD: {
        title: 'dashboard',
        isProtected: true,
        isVisible: (master: any) => {
            if (master?.properties && master?.parts_to_show?.enable_customer_config) {
                return master?.config?.is_international_customer ? false : master?.properties?.Analytics;
            }
            return true;
        },
    },
    REMITTANCE: undefined,
    INVOICE_REPORT: {
        title: 'Invoice Report',
        isProtected: true,
        isVisible: (master: any) => {
            // Should honor existing check in the Reports tab
            if (master?.Customer?.is_cpdp) {
                return false;
            }

            // to hide using the customer profile configuration
            if (master?.properties && master?.parts_to_show?.enable_customer_config) {
                return master?.properties?.Invoices && master?.customerUserPermissions?.financials_view;
            }
            return true;
        },
    },
    REPORT: undefined,
    REMITTANCE_REPORT: {
        title: 'COD Remittance',
        isProtected: true,
        isVisible: (master: any) => {
            // Should honor existing check in the Reports tab
            if (master?.Customer?.consignee_type !== 'B2C') {
                return false;
            }

            // to hide using the customer profile configuration
            if (master?.properties && master?.parts_to_show?.enable_customer_config) {
                return master?.properties?.cod_remittance && master?.customerUserPermissions?.financials_view;
            }
            return true;
        },
    },
    ADDITIONAL_SERVICES: {
        title: 'supplementary_services',
        isProtected: true,
        isVisible: (master: any) => master?.config?.customer_portal_config?.enable_supplementary_services_module,
    },
    SSO_LOGIN_REQUEST: undefined,
    CONSIGNOR_MANAGEMENT: {
        title: 'Consignor Admin',
        isProtected: true,
        isVisible: (master: any) => master?.config?.is_international_customer || false,
    },
    SELLER_DETAILS: {
        title: 'Consignor Details',
        isProtected: true,
        isVisible: (master: any) => master?.config?.is_international_customer || false,
    },
    RATE_CALCULATOR: {
        title: 'Rate Calculator',
        isProtected: true,
        isVisible: (master: any) => {
            return master?.config?.customer_portal_config?.show_rate_calculator
                && master?.config?.customer_portal_config?.enable_serviceability;
        },
    },
    PINCODE_SERVICEABILITY: {
        title: 'pincode_serviceability',
        isProtected: true,
        isVisible: (master: any) => {
            let flag = true;
            if (master?.properties && master?.parts_to_show?.enable_customer_config) {
                flag = master?.properties?.pincode_serviceability;
            }
            return flag && !master?.config?.customer_portal_consignment_config?.is_international_client;
        },
    },
    USER_MANAGEMENT: {
        title: 'user_management',
        isProtected: true,
        isVisible: (master: any) => {
            if (master?.properties && master?.parts_to_show?.enable_customer_config) {
                return master?.customerUserPermissions?.user_management;
            }
            return true;
        },
    },
};

export enum ZIndex {
    // Z-index for application
    // Prefer this over using hardcoded z-index values
    // Strictly avoid using z-index equal to 1000 or above, as it may conflict with antd components
    iframe = 500,
    navbar = 502,
    sideMenu = 501,
    loader = 10,
    forms = 601,
}

export const paginationOptions = [
    { label: '20', value: '20' },
    { label: '50', value: '50' },
    { label: '100', value: '100' },
];


export const formRules = {
    required: {
        required: true,
        message: 'Required',
    },
    pattern: {
        pattern: /^[^\s]+$/,
        message: 'No whitespace allowed',
    },
    number: {
        pattern: /^[0-9]*$/,
        message: 'Only Integer allowed',
    },
    max: {
        max: 50,
        message: 'Max length allowed is 50',
    },
    maxNumber1000: {
        pattern: /^(?:[1-9]\d{0,2}|1000)$/,
        message: 'Max number allowed is 1000',
    },
    maxNumber100: {
        pattern: /^(?:[1-9]\d?|100)$/,
        message: 'Max number allowed is 100',
    },
};

export const languageCodeMapping: any = {
    en: {
        prettyName: 'English',
    },
    hi: {
        prettyName: 'Hindi',
    },
    ba: {
        prettyName: 'Bahasa',
    },
    ar: {
        prettyName: 'Arabic',
    },
    hb: {
        prettyName: 'Hebrew',
    },
    us: {
        prettyName: 'English(US)',
    },
    ger: {
        prettyName: 'German',
    },
    'en-EU': {
        prettyName: 'English-EU',
    },
    fr: {
        prettyName: 'French',
    },
    en_MY: {
        prettyName: 'English (Malaysia)',
    },
    en_ar: {
        prettyName: 'English (Aramex)',
    },
    pt: {
        prettyName: 'Portuguese',
    },
    ru: {
        prettyName: 'Russian',
    },
    vi: {
        prettyName: 'Vietnamese',
    },
    sp: {
        prettyName: 'Spanish',
    },
    'en-ARAMEXVW': {
        prettyName: 'English (Aramex VW)',
    },
    'yp-ar': {
        prettyName: 'Arabic (Yemen)',
    },
};

export const SEARCH_TIMEOUT = 500;
